import React from "react";
import { createClasses } from "@bloomberg/media-ui-core";
import styles from "./styles.module.css";

const LEGEND_ITEMS = [
  { color: "bg-red-refresh2024-700", label: "<= -3%" },
  { color: "bg-red-refresh2024-500", label: "" },
  { color: "bg-red-refresh2024-300", label: "" },
  { color: "bg-gray-300", label: "0" },
  { color: "bg-green-refresh2024-300", label: "" },
  { color: "bg-green-refresh2024-500", label: "" },
  { color: "bg-green-refresh2024-700", label: `>= +3%` },
];

export default function HeatmapLegend() {
  return (
    <div className={styles.heatmapLegendContainer}>
      <div className={styles.heatmapLegend}>
        <div className={styles.legendColorBar}>
          {LEGEND_ITEMS.map((item, index) => (
            <div
              key={index}
              className={createClasses([styles.legendItem, item.color])}
            />
          ))}
        </div>
        <div className={styles.legendLabel}>
          {LEGEND_ITEMS.map((item, index) => (
            <div key={index} className={styles.legendLabelText}>
              {item.label}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
